// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"5f66e6b8","703":"84dea163","787":"f6e3b87e"}[chunkId] + ".chunk.js";
};